import { useSyncExternalStore } from "react";
const emptySubscribe = () => () => {};

/**
 * False during SSR and the hydration render (matching the server HTML),
 * true from the first client render on — so client-side navigations render
 * the persisted layout immediately instead of after a post-mount effect.
 */
export function useIsHydrated() {
  return useSyncExternalStore(emptySubscribe, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return true;
}